<script lang="ts" module>
  import { createToaster, melt } from "@melt-ui/svelte";
  import { fly } from "svelte/transition";
  import { flip } from "svelte/animate";
  import Cross from "../../icons/Cross.svelte";
  import type { Component } from "svelte";

  export type ToastData = {
    text: string;
    icon?: Component;
    iconClass?: string;
  };

  const {
    elements: { content, description, close },
    helpers,
    states: { toasts },
    actions: { portal },
  } = createToaster<ToastData>();

  export const addToast = helpers.addToast;
  export const removeToast = helpers.removeToast;
</script>

<div class="fixed right-8 bottom-2 z-50 m-4 flex flex-col items-end gap-1.5" use:portal>
  {#each $toasts as { id, data } (id)}
    {@const __MELTUI_BUILDER_2__ = $close(id)}
    {@const __MELTUI_BUILDER_1__ = $description(id)}
    {@const __MELTUI_BUILDER_0__ = $content(id)}
    <div
      class="max-w-[340px] rounded-xl bg-mono-000 px-2 py-1 text-sm text-pretty text-foreground-primary shadow-border-popover"
      {...__MELTUI_BUILDER_0__} use:__MELTUI_BUILDER_0__.action
      in:fly={{ duration: 150, y: "100%" }}
      out:fly={{ duration: 150, y: "100%" }}
      animate:flip={{ duration: 100 }}
    >
      <div class="flex items-center justify-between gap-4">
        <div class="flex items-center gap-2 p-2">
          {#if data.icon}
            <div class="flex shrink-0 items-center justify-center {data.iconClass ?? ''}">
              <data.icon size={16} />
            </div>
          {/if}
          <div {...__MELTUI_BUILDER_1__} use:__MELTUI_BUILDER_1__.action>
            {data.text}
          </div>
        </div>
        <button
          class="ease flex h-7 w-7 shrink-0 items-center justify-center rounded-md text-foreground-tertiary transition-colors duration-200 hover:bg-mono-100"
          aria-label="close notification"
          type="button"
          {...__MELTUI_BUILDER_2__} use:__MELTUI_BUILDER_2__.action
        >
          <Cross size={14} />
        </button>
      </div>
    </div>
  {/each}
</div>
